$(document).ready(function(){

    $('.col_banner_btn_mn').click(function(evt){
        evt.preventDefault();
        $('html, body').animate({
            scrollTop: $(".products_holder").offset().top-100
        }, 500);
    });

    $(document).on("click",".ht_btn_title",function(evt) {
      evt.preventDefault();

      $('html, body').animate({
          scrollTop: $(".ht_subscribe_box").offset().top
      }, 500);
    });

    $('.rp_close_popup').click(function(evt){
        evt.preventDefault();
        $('.rp_outer').hide();
        document.cookie = "popupas=nerodyti2; expires=Thu, 1 Jan 2030 00:00:00 UTC; path=/";
    });


    $('.i1jC3nY2siqoGfAm3').click(function(evt){
      var CurrentUrl = String(window.location.href);
      if (CurrentUrl.indexOf('/products') != -1){
         evt.preventDefault();
          $('html, body').animate({
              scrollTop: $("#product_temp_main").offset().top-200
          }, 500);
      }
     
    });


    var targetElement = $('.main_cta')[0]; // Get the first element with class "main_cta"

    if (targetElement) {
        // Create a MutationObserver instance
        var observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(function (mutation) {
                if ( mutation.attributeName === 'v_id') {
                    // console.log("Attribute 'your-attribute' changed!");
                    // console.log("New value: ", $(mutation.target).attr(mutation.attributeName));
                    $('.s_sub_usp_tosale').hide();
                    $('.s_sub_usp_tosale[data-id="'+$(mutation.target).attr(mutation.attributeName)+'"]').show();
  
                    $('.sub_saving_lines').hide();
                    $('.sub_saving_lines[data-id="'+$(mutation.target).attr(mutation.attributeName)+'"]').show();
                    
                }
            });
        });
  
        // Configure the observer to watch for specific attribute changes
        observer.observe(targetElement, { attributes: true });
    }
 
});


window.asl_loaded = function(){
    var country = asl_country();
    console.log(country);

    const countryNames = {
        'AF': 'Afghanistan',
        'AX': 'Åland Islands',
        'AL': 'Albania',
        'DZ': 'Algeria',
        'AS': 'American Samoa',
        'AD': 'Andorra',
        'AO': 'Angola',
        'AI': 'Anguilla',
        'AQ': 'Antarctica',
        'AG': 'Antigua and Barbuda',
        'AR': 'Argentina',
        'AM': 'Armenia',
        'AW': 'Aruba',
        'AU': 'Australia',
        'AT': 'Austria',
        'AZ': 'Azerbaijan',
        'BS': 'Bahamas',
        'BH': 'Bahrain',
        'BD': 'Bangladesh',
        'BB': 'Barbados',
        'BY': 'Belarus',
        'BE': 'Belgium',
        'BZ': 'Belize',
        'BM': 'Bermuda',
        'BT': 'Bhutan',
        'BO': 'Bolivia (Plurinational State of)',
        'BQ': 'Bonaire, Sint Eustatius and Saba',
        'BA': 'Bosnia and Herzegovina',
        'BW': 'Botswana',
        'BV': 'Bouvet Island',
        'BR': 'Brazil',
        'IO': 'British Indian Ocean Territory',
        'BN': 'Brunei Darussalam',
        'BG': 'Bulgaria',
        'BF': 'Burkina Faso',
        'BI': 'Burundi',
        'KH': 'Cambodia',
        'CM': 'Cameroon',
        'CA': 'Canada',
        'KY': 'Cayman Islands',
        'CL': 'Chile',
        'CN': 'China',
        'CX': 'Christmas Island',
        'CC': 'Cocos (Keeling) Islands',
        'CO': 'Colombia',
        'KM': 'Comoros',
        'CK': 'Cook Islands',
        'CR': 'Costa Rica',
        'HR': 'Croatia',
        'CU': 'Cuba',
        'CW': 'Curaçao',
        'CY': 'Cyprus',
        'CZ': 'Czech Republic',
        'DK': 'Denmark',
        'DJ': 'Djibouti',
        'DM': 'Dominica',
        'DO': 'Dominican Republic',
        'EC': 'Ecuador',
        'EG': 'Egypt',
        'SV': 'El Salvador',
        'GQ': 'Equatorial Guinea',
        'ER': 'Eritrea',
        'EE': 'Estonia',
        'ET': 'Ethiopia',
        'FK': 'Falkland Islands (Malvinas)',
        'FO': 'Faroe Islands',
        'FJ': 'Fiji',
        'FI': 'Finland',
        'FR': 'France',
        'GF': 'French Guiana',
        'PF': 'French Polynesia',
        'TF': 'French Southern Territories',
        'GA': 'Gabon',
        'GM': 'Gambia',
        'GE': 'Georgia',
        'DE': 'Germany',
        'GH': 'Ghana',
        'GI': 'Gibraltar',
        'GR': 'Greece',
        'GL': 'Greenland',
        'GD': 'Grenada',
        'GP': 'Guadeloupe',
        'GU': 'Guam',
        'GT': 'Guatemala',
        'GG': 'Guernsey',
        'GY': 'Guyana',
        'HT': 'Haiti',
        'HM': 'Heard Island and McDonald Islands',
        'VA': 'Holy See',
        'HN': 'Honduras',
        'HK': 'Hong Kong',
        'HU': 'Hungary',
        'IS': 'Iceland',
        'IN': 'India',
        'ID': 'Indonesia',
        'IR': 'Iran (Islamic Republic of)',
        'IQ': 'Iraq',
        'IE': 'Ireland',
        'IM': 'Isle of Man',
        'IL': 'Israel',
        'IT': 'Italy',
        'JM': 'Jamaica',
        'JP': 'Japan',
        'JE': 'Jersey',
        'JO': 'Jordan',
        'KZ': 'Kazakhstan',
        'KE': 'Kenya',
        'KI': 'Kiribati',
        'KP': "Korea (Democratic People's Republic of)",
        'KR': 'Korea (Republic of)',
        'KW': 'Kuwait',
        'KG': 'Kyrgyzstan',
        'LA': "Lao People's Democratic Republic",
        'LV': 'Latvia',
        'LB': 'Lebanon',
        'LS': 'Lesotho',
        'LR': 'Liberia',
        'LY': 'Libya',
        'LI': 'Liechtenstein',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'MO': 'Macao',
        'MK': 'Macedonia (the former Yugoslav Republic of)',
        'MG': 'Madagascar',
        'MW': 'Malawi',
        'MY': 'Malaysia',
        'MV': 'Maldives',
        'ML': 'Mali',
        'MT': 'Malta',
        'MH': 'Marshall Islands',
        'MQ': 'Martinique',
        'MR': 'Mauritania',
        'MU': 'Mauritius',
        'YT': 'Mayotte',
        'MX': 'Mexico',
        'FM': 'Micronesia (Federated States of)',
        'MD': 'Moldova (Republic of)',
        'MC': 'Monaco',
        'MN': 'Mongolia',
        'ME': 'Montenegro',
        'MS': 'Montserrat',
        'MA': 'Morocco',
        'MZ': 'Mozambique',
        'MM': 'Myanmar',
        'NA': 'Namibia',
        'NR': 'Nauru',
        'NP': 'Nepal',
        'NL': 'Netherlands',
        'NC': 'New Caledonia',
        'NZ': 'New Zealand',
        'NI': 'Nicaragua',
        'NE': 'Niger',
        'NG': 'Nigeria',
        'NU': 'Niue',
        'NF': 'Norfolk Island',
        'MP': 'Northern Mariana Islands',
        'NO': 'Norway',
        'OM': 'Oman',
        'PK': 'Pakistan',
        'PW': 'Palau',
        'PS': 'Palestine, State of',
        'PA': 'Panama',
        'PG': 'Papua New Guinea',
        'PY': 'Paraguay',
        'PE': 'Peru',
        'PH': 'Philippines',
        'PN': 'Pitcairn',
        'PL': 'Poland',
        'PT': 'Portugal',
        'PT': 'Portugal',
        'PW': 'Palau',
        'PS': 'Palestine, State of',
        'PA': 'Panama',
        'PG': 'Papua New Guinea',
        'PY': 'Paraguay',
        'PE': 'Peru',
        'PH': 'Philippines',
        'PN': 'Pitcairn',
        'PL': 'Poland',
        'PR': 'Puerto Rico',
        'QA': 'Qatar',
        'RE': 'Réunion',
        'RO': 'Romania',
        'RU': 'Russian Federation',
        'RW': 'Rwanda',
        'BL': 'Saint Barthélemy',
        'SH': 'Saint Helena, Ascension and Tristan da Cunha',
        'KN': 'Saint Kitts and Nevis',
        'LC': 'Saint Lucia',
        'MF': 'Saint Martin (French part)',
        'PM': 'Saint Pierre and Miquelon',
        'VC': 'Saint Vincent and the Grenadines',
        'WS': 'Samoa',
        'SM': 'San Marino',
        'ST': 'Sao Tome and Principe',
        'SA': 'Saudi Arabia',
        'SN': 'Senegal',
        'RS': 'Serbia',
        'SC': 'Seychelles',
        'SG': 'Singapore',
        'SX': 'Sint Maarten (Dutch part)',
        'SK': 'Slovakia',
        'SI': 'Slovenia',
        'SB': 'Solomon Islands',
        'SO': 'Somalia',
        'ZA': 'South Africa',
        'GS': 'South Georgia and the South Sandwich Islands',
        'SS': 'South Sudan',
        'ES': 'Spain',
        'LK': 'Sri Lanka',
        'SD': 'Sudan',
        'SR': 'Suriname',
        'SJ': 'Svalbard and Jan Mayen',
        'SZ': 'Swaziland',
        'SE': 'Sweden',
        'CH': 'Switzerland',
        'SY': 'Syrian Arab Republic',
        'TW': 'Taiwan, Province of China',
        'TJ': 'Tajikistan',
        'TZ': 'Tanzania, United Republic of',
        'TH': 'Thailand',
        'TL': 'Timor-Leste',
        'TG': 'Togo',
        'TK': 'Tokelau',
        'TO': 'Tonga',
        'TT': 'Trinidad and Tobago',
        'TN': 'Tunisia',
        'TR': 'Turkey',
        'TM': 'Turkmenistan',
        'TC': 'Turks and Caicos Islands',
        'TV': 'Tuvalu',
        'UG': 'Uganda',
        'UA': 'Ukraine',
        'AE': 'United Arab Emirates',
        'GB': 'United Kingdom of Great Britain and Northern Ireland',
        'US': 'United States of America',
        'UM': 'United States Minor Outlying Islands',
        'UY': 'Uruguay',
        'UZ': 'Uzbekistan',
        'VU': 'Vanuatu',
        'VE': 'Venezuela (Bolivarian Republic of)',
        'VN': 'Viet Nam',
        'VG': 'Virgin Islands (British)',
        'VI': 'Virgin Islands (U.S.)',
        'WF': 'Wallis and Futuna',
        'EH': 'Western Sahara',
        'YE': 'Yemen',
        'ZM': 'Zambia',
        'ZW': 'Zimbabwe'
    };


    if (countryNames.hasOwnProperty(country)) {
        country = countryNames[country];
    }

    console.log('Country is set to: ', country);

    $('.rp_currentCountry').html(country);



    var cookies = document.cookie.split(';');
    var popupas = true;
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.indexOf('popupas=nerodyti2') === 0) {
            popupas = false;
        }
    }
    var country = asl_country();
    console.log(popupas, country, 'CHECKER FORS POPUP');
    if (country == 'de' || country == "DE"){
        if (popupas == true){
            $('.rp_outer').css('display', 'flex');
            setTimeout(function(){
                $('.rp_outer').addClass('active');
            },500);
        }
    }
    else{
        
    }
    
}

$('.product-btn-cta').on('click', function (e) {
  e.preventDefault();
  const offsetTop = $('#product-main').offset().top - 90;
  $('html, body').animate({
    scrollTop: offsetTop
  }, 800);
});

$(document).ready(function () {
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});

$(document).on("click",".ingre_button",function(evt) {
    evt.preventDefault();

    var mode = $(this).attr('data');
    $('.ingredients_outer_data').hide();
    
    $('.ingredients_outer_data[data="'+mode+'"]').show();
   
});


$(document).ready(function(){
    var cookies = document.cookie.split(';');
    var cookiesSet = false;
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.indexOf('cookies=set3') === 0) {
        cookiesSet = true;
        }
    }
    if (cookiesSet == false){
        $('.sp_cookies_out').show();
    }

    $('.sp_cookies_btn.primary').click(function(evt){
        evt.preventDefault();
        $('.sp_cookies_out').hide();
        document.cookie = "cookies=set3; expires=Thu, 1 Jan 2029 00:00:00 UTC; path=/";

        $('#shopify-pc__banner__btn-accept').trigger('click');
    });

    $('.sp_cookies_btn.secondary').click(function(evt){
        evt.preventDefault();
        $('.sp_cookies_out').hide();
        document.cookie = "cookies=set3; expires=Thu, 1 Jan 2029 00:00:00 UTC; path=/";

        $('#shopify-pc__banner__btn-decline').trigger('click');
    });


    $(document).on("click",".flavour-option .s_sub_quan_selector",function() {
        var selectedFlavor =  $(this).attr('option-value-handle');
        console.log(selectedFlavor, 'SELECTED FLAVOUR FOR DYNAMIC CONTENT');

        if (typeof nutrition_image_update === 'function'){
            nutrition_image_update(selectedFlavor);
        }

        $(".pp_flavor_content, .s_ingre_flavoured, .s_desc__js").each(function () {
            var flavor_options = $(this).attr("data").trim().split(",");
            var flavor_selected = false;
            for (let index = 0; index < flavor_options.length; index++) {
                // console.log("flavor option", flavor_options[index]);
                if ((flavor_options[index]).trim() == selectedFlavor){
                    flavor_selected = true;
                }
            }
            // console.log("flavor_option", flavor_options, selectedFlavor); 
            if (flavor_selected == true){
                $(this).removeClass('hidden');
            }    
            else{
                $(this).addClass('hidden');
            }  
        });
    });


    // 3 options selection
    $('.pp_quantity_selection_box').click(function(){
        $(this).closest('.pp_quantity_selection').find('.pp_quantity_selection_box').removeClass('active');
        $(this).addClass('active');

        selectVariant();
    });

    $('.pp_flavour_box_outer').click(function(){
        $(this).closest('.pp_flavour_grid').find('.pp_flavour_box_outer').removeClass('active');
        $(this).addClass('active');

        selectVariant();
    });

    $('.pp_selector_head').click(function(){
        $('.pp_mode_selector').removeClass('active');
        $(this).closest('.pp_mode_selector').addClass('active');
        $(this).closest('.pp_mode_selector').find('.pp_flavour_box_outer.firstFlavor').trigger('click');

        var mode = $(this).closest('.pp_mode_selector').attr('data');

        if (mode == 'subscribe_bundle'){
            $('.pp_quantity_selection_box.pp_noaccessories').hide();
            $('.pp_quantity_selection_box.pp_accessories').show();

            $('.pp_quantity_selection_box.pp_accessories.firstSelection').trigger('click');
        }
        else{
            $('.pp_quantity_selection_box.pp_noaccessories').show();
            $('.pp_quantity_selection_box.pp_accessories').hide();

            $('.pp_quantity_selection_box.pp_noaccessories.firstSelection').trigger('click');
        }

        if (mode == 'onetime_bags' ){
            $('.pp_very_small_text[data="sub"]').hide();
            $('.pp_price_sub_content').css('display', 'none');
            $('.pp_sub_price').hide();
            $('.pp_onetime_price').show();

        }
        // else if(mode == 'subscribe_bundle' ){
        //   $('.pp_price_sub_content').css('display', 'none');
        // }
        else{
            $('.pp_very_small_text[data="sub"]').show();
            $('.pp_price_sub_content').css('display', 'unset');
            $('.pp_sub_price').show();
            $('.pp_onetime_price').hide();
            
        }
       
    });

    function selectVariant(){
        var fullTitle = '';
        var color = $('.pp_mode_selector.active').find('.pp_flavour_box_outer.active').attr('data');
        var quantity = $('.pp_quantity_selection_box.active').attr('data');
        var fullFlavor = $('.pp_mode_selector.active').find('.pp_flavour_box_outer.active').attr('data-full');

        var currentUrl = String(window.location.href);
        if (
            currentUrl.indexOf('rainbow-dust-starter-kit-2') != -1 || 
            currentUrl.indexOf('us-offer') != -1 
        ){
            fullTitle = color; 
        }
        else{
            fullTitle = color + '-' + quantity;
        }
        
        console.log(fullTitle, 'FULLT TITLE');

        $('.pp_gift_changebale_gift').hide();
        if (String(fullTitle).indexOf('1x') != -1){
            $('.pp_gift_changebale_gift[data="1"]').show();
        }
        else if (String(fullTitle).indexOf('2x') != -1){
            $('.pp_gift_changebale_gift[data="2"]').show();
        }
        else if (String(fullTitle).indexOf('3x') != -1){
            $('.pp_gift_changebale_gift[data="3"]').show();
        }
        var currentId = 'none';

        var totalPrice = '';
        var currentSellingPlan = '';

        var currentMode = $('.pp_mode_selector.active').attr('data');
        $('.pp_variants_selection__js').each(function(){
           if($(this).attr('data-title') == fullTitle){
            currentId = $(this).attr('data-id');
            currentSellingPlan = $(this).attr('data-selling-plan');

            if (currentMode == 'onetime_bags'){
                totalPrice = $(this).attr('data-price');
            }
            else{
                totalPrice = $(this).attr('data-selling-price');
            }
           } 
        });

        var mode = $('.pp_mode_selector.active').attr('data');

        $('.main_cta').attr('v_id', currentId);

        if (mode == 'onetime_bags' ){
            $('.main_cta').attr('s_id', '');
        }
        else{
            $('.main_cta').attr('s_id', currentSellingPlan);
        }

        $('.pp_medium_text').hide();
        $('.pp_medium_text[data-id="'+currentId+'"]').show();

        $('.swip_thumb_image__js').hide();
        $('.swip_thumb_image__js[data-id="'+currentId+'"]').show();

        console.log(currentId, 'HEREHERERERERERE');

        $('.pp_mode_selector.active').find('.pp_price_box').hide();
        $('.pp_mode_selector.active').find('.pp_price_box[data-id="'+currentId+'"]').show();

        $('.main_cta  .total_price').html(totalPrice);

        $('.p_price_outer_id').hide();
        $('.p_price_outer_id[data-id="'+currentId+'"]').css('display', 'flex');

       


        var selectedFlavor = color;
        
        $('.pp_flavor_content').addClass('hidden');
        $('.pp_flavor_content[data="'+selectedFlavor+'"]').removeClass('hidden');

        $('.s_ingre_flavoured').addClass('hidden');
        $('.s_ingre_flavoured[data="'+selectedFlavor+'"]').removeClass('hidden');

        $('.s_desc__js').addClass('hidden');
        $('.s_desc__js[data="'+selectedFlavor+'"]').removeClass('hidden');

        $('.upsell_box').hide();
      
        $('.upsell_box[data-flavor="'+fullFlavor +'"]').show();
        

     

        setBadges();
    }


    function setBadges(){
        $('.pp_quantity_selection_box').each(function(){
            var size = $(this).attr('data');
            var color = $('.pp_mode_selector.active').find('.pp_flavour_box_outer.active').attr('data');

            var fullTitle = color + '-' + size;

            var currentId = 'none';
            var saveBadge = '0';

            var mode = $('.pp_mode_selector.active').attr('data');

            console.log('Mode is: ', mode);

            $('.pp_variants_selection__js').each(function(){
                if($(this).attr('data-title') == fullTitle){
                 currentId = $(this).attr('data-id');
                 if (mode == 'onetime_bags' ){
                    saveBadge = $(this).attr('data-save-otp');
                    console.log('HERE', saveBadge, currentId);
                 }
                 else{
                    saveBadge = $(this).attr('data-save-sub');
                 }
                } 
             });

             $(this).find('.pp_quantity_badge').html(saveBadge);

        });
    }

    setBadges();

    // Preselecting first upsell
    $('.upsell_box[data-flavor="Coffee"]').show();



    function setShippingRates(){
        var endpoint = 'https://apip.cc/json';
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                var response = JSON.parse(this.responseText);
                if(response.status !== 'success') {
                    console.log('Query failed: ' + response.message);
                    return;
                }
                // Redirect based on the country code
                console.log(response.CountryCode);

                // response.CountryCode = 'IS';
                if (response.CountryCode == 'IS'){
                    $('.s_sub_usp.secureShipping').show();
                    $('.s_sub_usp.freeShipping').hide();
                }
                else{
                    $('.s_sub_usp.secureShipping').hide();
                    $('.s_sub_usp.freeShipping').show();
                }
            }
        };
        xhr.open('GET', endpoint, true);
        xhr.send();
    }

    setShippingRates();


    function preselectGummies(){
        var currentUrl = String(window.location.href);
        if (currentUrl.indexOf('?moonChews') != -1){
            $('.moon.chews').closest('.s_sub_quan_selector').trigger('click');
        }
    }

    preselectGummies();


    $('.pp_hydro_whats_inside_cell').click(function(){
        $(this).toggleClass('active');
    });

    $('.goToTop').click(function(evt){
        evt.preventDefault();
        $('html, body').animate({
            scrollTop: $("#product_temp_main").offset().top-200
        }, 500);
    });
    

    $('.pp_sticky_cta_edit').click(function(evt){
        evt.preventDefault();
        $('html, body').animate({
            scrollTop: $(".subs_selector_wrapper").offset().top-100
        }, 500);
    });

    $(document).scroll(function() {

        if ( $(document).scrollTop() >= 5 ) {
            $('#shopify-section-header').addClass('mustWhite');
        }
        else{
            $('#shopify-section-header').removeClass('mustWhite');
        }

        if ( $(document).scrollTop() >= 100 ) {
            $('.pp_sticky_atc_container').addClass('visible');
        } 
        else{
            $('.pp_sticky_atc_container').removeClass('visible');
        }
    });


    $('.in_switch_out').click(function(){
        $(this).closest('.in_section_switch_container_grid').find('.in_switch_out').removeClass('active');
        $(this).addClass('active');
        var getSection = $(this).attr('data-section');
        var data = $(this).attr('data');
        if (getSection == 'how'){
            $('.in_how_use_outer').removeClass('active');
            $('.in_how_use_outer[data="'+data+'"]').addClass('active');
        }
        if (getSection == 'counts'){
            $('.pp_hydro_whats_inside_grid.hmpage').removeClass('active');
            $('.pp_hydro_whats_inside_grid.hmpage[data="'+data+'"]').addClass('active');
        }
    });

    $('.in_bestsellers_grid.in_bestsellers_carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '40px',
        dots: true,
        arrows: true
      });

      $('.in_bestsellers_nav_right').click(function(){
        $('.in_bestsellers_grid.in_bestsellers_carousel').find('.slick-next').trigger('click');
      });

      $('.in_bestsellers_nav_left').click(function(){
        $('.in_bestsellers_grid.in_bestsellers_carousel').find('.slick-prev').trigger('click');
      });

      $('.in_faq_box').click(function(){
        $(this).toggleClass('active');
        $(this).find('.in_faq_content').slideToggle();
      });

      $('.in_faq_expand_btn').click(function(){
        $('.in_faq_container').toggleClass('expanded');
        $('.needsBeHidden').toggleClass('hided');
        $(this).toggleClass('active')
      });


      $('.revs_in_bestsellers_nav_left').click(function(){
        $('.swiper-button-prev').trigger('click');
      });

      $('.revs_in_bestsellers_nav_right').click(function(){
        $('.swiper-button-next').trigger('click');
      });

     $('.an_bar_carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000
      });


      
}); 

